(function($) {
	'use strict';

	$.widget('msv.share', {

		options: {
			el: {},
			facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
			linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=',
			googleplus: 'https://plus.google.com/share?url=',
			whatsapp: 'whatsapp://send?text=',
			twitter: 'https://twitter.com/home?status=',
			youtube: 'https://www.youtube.com/channel/UC6D0t4ecpz7D0RcJaUovkcA'
		},

		_create: function() {
			var self = this;
			/**/
			this.options.el.share = $(".share");
			this.options.el.shareProviders = $(".share__providers");
			/**/
			var type = this.options[this.element.data("social")];
			var url = encodeURIComponent(window.location.href);
			var shareUrl = type + url;
			/**/
			this._on({
				'click': function(evt) {
					evt.preventDefault();
					self._popupCenter(shareUrl);
				}
			});
			// this.options.el.share.hover(function () {
			// 	self.options.el.shareProviders.fadeIn();
			// }, function () {
			// 	self.options.el.shareProviders.fadeOut();
			// })
		},

		_popupCenter: function(url) {
			var w = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
			var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 400;
			var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left,
				dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top,
				width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width,
				height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height,
				left = width / 2 - w / 2 + dualScreenLeft,
				top = height / 2 - h / 2 + dualScreenTop,
				newWindow = window.open(url, 'Share', "scrollbars=yes, width=".concat(w, ", height=").concat(h, ", top=").concat(top, ", left=").concat(left)); // Puts focus on the newWindow  
		
			window.focus ? newWindow.focus() : '';
		}

	});

})(jQuery);